import { DesktopSidebar } from './DesktopSidebar';
import { DesktopHeader } from './DesktopHeader';

export const DesktopLayout = ({ children, headerTitle, headerActions }) => {
  return (
    <div className="td-desktop-layout">
      <DesktopSidebar />
      <div className="td-desktop-shell">
        <DesktopHeader title={headerTitle} actions={headerActions} />
        <main className="td-desktop-content">
          <div className="td-desktop-content-inner">{children}</div>
        </main>
      </div>
    </div>
  );
};
